import LegalPage from '@/pages/legal/LegalPage';

const sections = [
  { titleKey: 'legal.privacy_section1_title', textKey: 'legal.privacy_section1_text' },
  { titleKey: 'legal.privacy_section2_title', textKey: 'legal.privacy_section2_text' },
  { titleKey: 'legal.privacy_section3_title', textKey: 'legal.privacy_section3_text' },
  { titleKey: 'legal.privacy_section4_title', textKey: 'legal.privacy_section4_text' },
  { titleKey: 'legal.privacy_section5_title', textKey: 'legal.privacy_section5_text' },
  { titleKey: 'legal.privacy_section6_title', textKey: 'legal.privacy_section6_text' },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      titleKey="legal.privacy_title"
      lastUpdatedKey="legal.privacy_last_updated"
      introKey="legal.privacy_intro"
      sections={sections}
      contactKey="legal.privacy_contact"
      seo={{
        title: 'Privacy Policy - Texio | Textile ERP Data Protection',
        description: 'Texio Privacy Policy — how we collect, use, store, and protect your textile factory data. Learn about your rights, our security practices, and our commitment to data privacy.',
        keywords: 'Texio privacy policy, textile ERP data protection, factory data privacy, ERP security policy',
        canonicalUrl: '/privacy',
      }}
    />
  );
}